import { render, staticRenderFns } from "./LmCheckbox.vue?vue&type=template&id=961b90a6&scoped=true&"
import script from "./LmCheckbox.vue?vue&type=script&lang=js&"
export * from "./LmCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./LmCheckbox.vue?vue&type=style&index=0&id=961b90a6&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961b90a6",
  null
  
)

export default component.exports